import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function parseFileNameFromUrl(url) {
  // Find the index of the second occurrence of "%2"
  const secondPercent2Index = url.indexOf("%2", url.indexOf("%2") + 1);

  // Find the index of the question mark "?"
  const questionMarkIndex = url.indexOf("?");

  // Check if both indices were found in the URL
  if (secondPercent2Index !== -1 && questionMarkIndex !== -1) {
    // Slice the string to extract the file name between the second "%2" and the "?"
    const fileName = url.slice(secondPercent2Index + 3, questionMarkIndex);
    return decodeURIComponent(fileName); // Decode any URL-encoded characters
  } else {
    // Return an empty string or handle the error as needed
    return "";
  }
}
const GalleryProfile = ({ imageUrls }) => {
  return (
    // <Container>
    <>
      <Col className='text-center mt-4 image-grid'>
        {imageUrls.map((imageUrl, index) => (
          <Col key={index} className='mb-2'>
            {/* <Col key={index} xs={12} md={6} lg={6} className='mb-4'> */}
            <div className='gallery-item'>
              <img
                src={imageUrl}
                alt={`Img ${index + 1}`}
                className='gallery-image img-fluid'
              />
            </div>
            <div className='whiteText text-center image-title'>
              {parseFileNameFromUrl(imageUrl)}
            </div>
          </Col>
        ))}
      </Col>
    </>
    // </Container>}
  );
};

export default GalleryProfile;
